import { GHubThemeType } from '../../../modules/theme';
import {
  alexForbesDoughnutChartColors,
  glacierDoughnutChartColors
} from '../../../utils/chart-colors/chart-colors';

const defaultColors = ['#4CAF50', '#FF9800', '#2196F3', '#E91E63', '#9C27B0'];

export const getColors = (theme: GHubThemeType) => {
  switch (theme) {
    case 'af':
      return alexForbesDoughnutChartColors;
    case 'glacier':
      return glacierDoughnutChartColors;
    default:
      return defaultColors;
  }
};

export const getLabels = (labels: string[], values: number[]) => {
  const total = values.reduce((acc, value) => acc + value, 0);
  return labels.map((label, idx) => {
    const value = values.at(idx) ?? 0;
    const portion = total ? (value / total) * 100 : 0;
    return `${label} \t - \t ${portion.toFixed(2)}%`;
  });
};
